@if (!editMode) {
  <h2 mat-dialog-title>Modul Beschreibung hinzufügen</h2>
}
@if (editMode) {
  <h2 mat-dialog-title>Modul Beschreibung editieren</h2>
}
<mat-dialog-content>
  Editor unterstützt Markdown Syntax -
  <a href="https://www.markdownguide.org/cheat-sheet/">Dokumentation</a>
  <md-editor
    #md="ngModel"
    name="content"
    [(ngModel)]="content"
    [mode]="mode"
    [options]="editorOptions"
    required
    maxlength="600"
    height="400px"
  ></md-editor>
  <form
    [formGroup]="markdownForm"
    (ngSubmit)="updateOrCreateModule()"
    ngNativeValidate
    class="d-flex flex-column"
    >
    <button
      mat-raised-button
      color="primary"
      type="submit"
      [disabled]="!markdownForm.valid || submitting"
      >
      @if (editMode) {
        Speichern
      }
      @if (!editMode) {
        Hinzufügen
      }
    </button>
  </form>
</mat-dialog-content>
